export default theme => ({
  root: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.colors.transparentBlack,
    '& $previousButton, $nextButton': {
      position: 'absolute',
      height: 50,
      width: 50,
      top: '50%',
      transform: 'translateY(-50%)',
      cursor: 'pointer',
      '&:hover': {
        borderRadius: 2,
        backgroundColor: theme.colors.grey[700]
      }
    },
    '& $previousButtonContent, $nextButtonContent': {
      position: 'absolute',
      height: 32,
      width: 32,
      top: '50%',
      transform: 'translate(-50%, -50%)'
    }
  },
  content: {
    position: 'relative',
    height: 'calc(100vh - 50px)'
  },
  slider: {
    position: 'absolute',
    top: '50%',
    left: 0,
    right: 0,
    transform: 'translateY(-50%)',
    '& .slick-list': {
      position: 'relative',
      overflow: 'hidden'
    },
    '& .slick-track': {},
    '& .slick-slide': {
      width: '100vw',
      display: 'inline-block',
      whiteSpace: 'nowrap',
      verticalAlign: 'middle',
      margin: '0 auto'
    }
  },
  sliderImage: {
    height: '100%',
    textAlign: 'center',
    '& img': {
      maxHeight: 'calc(100vh - 50px - 20px)',
      maxWidth: '100vw',
      textAlign: 'center'
    }
  },
  previousButton: {
    left: 10
  },
  nextButton: {
    right: 10
  },
  previousButtonContent: {
    left: '50%'
  },
  nextButtonContent: {
    left: '50%'
  },
  chevronLeft: {
    transform: 'rotate(90deg)'
  },
  chevronRight: {
    transform: 'rotate(-90deg)'
  }
});